import script from "./Setup.vue?vue&type=script&lang=ts&setup=true"
export * from "./Setup.vue?vue&type=script&lang=ts&setup=true"

import "./Setup.vue?vue&type=style&index=0&id=29559bb0&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29559bb0"]])

export default __exports__